import { Box } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import { WebhooksList } from '@/components/modules/Webhooks/components/WebhooksList';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { ModuleCorePermissionProps } from '@/config/types';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

interface WebhooksProps extends ModuleCorePermissionProps {
  hideMerchantHints?: boolean;
}

const Webhooks = ({ canEdit = false, hideMerchantHints = false }: WebhooksProps) => {
  const { structure } = useUserContext();
  const { merchantId } = useParams();

  const userId = structure?.merchant.id ?? merchantId;

  if (!userId) return null;

  return (
    <>
      {!hideMerchantHints && (
        <Box mb={2} maxWidth={'50em'}>
          <Font variant={'body2'} color={'textPrimary'}>
            <Text tId={'WEBHOOKS_MERCHANT_TEXT'} />
          </Font>
        </Box>
      )}
      <WebhooksList userId={userId} editModeAllowed={canEdit} />
    </>
  );
};

export const WebhooksModule = withPermissionsModule(Webhooks);
